export default "__VITE_ASSET__79c82a29__"